import moment from "moment";
import React from "react";

import { MarkerStyles, MarkerStylesHover, PlannedPdcStyle } from "./markerStyles";
import { retailerLogos } from "./retailerLogos";

const MarkerColor = (displayOption, data) => {
  if (displayOption === "dn") {
    return MarkerColorDN(data.dn);
  } else if (displayOption === "pdl") {
    return MarkerColorPDL(data.pdl);
  }

  return MarkerColorLastVisitDate(data.last_visit_date);
};
const MarkerColorLastVisitDate = last_visit_date => {
  if (!last_visit_date) {
    return "red";
  }
  const threeMonthsPrior = moment().add(-3, "months");
  const lastVisitDate = moment(last_visit_date);
  if (lastVisitDate.diff(threeMonthsPrior) < 0) {
    return "#FFA500";
  }
  return "#00FF00";
};

const MarkerColorDN = dn => {
  if (!dn) {
    return "indigo";
  }
  if (dn > 90) {
    return "#00C2A8";
  } else if (dn > 80) {
    return "#00FF00";
  } else if (dn > 50) {
    return "#FFA500";
  }
  return "#FF0000";
};
const MarkerColorPDL = pdl => {
  if (!pdl) {
    return "indigo";
  }
  if (pdl >= 20.5) {
    return "#00FF00";
  } else if (pdl > 20) {
    return "#FFA500";
  }
  return "#FF0000";
};

class SalepointMarker extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = { hover: false, isPdcPlannedBlink: false };
  }
  componentDidMount() {
    this._isMounted = true;
    if (this.props.isPdcPlanned && this._isMounted) {
      this.launchBlink();
    }
  }
  launchBlink = () => {
    this.timer = setInterval(() => {
      this.setState(prevState => ({
        isPdcPlannedBlink: !prevState.isPdcPlannedBlink
      }));
    }, 500);
  };

  componentDidUpdate(prevProps) {
    if (this.props.isPdcPlanned === prevProps.isPdcPlanned) return;
    if (!this.props.isPdcPlanned) {
      clearInterval(this.timer);
    } else {
      this.launchBlink();
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { retailerId, last_visit_date, pdcLabel, onClick, onHover, dn, pdl } = this.props;
    const styleMarker =
      this.state.hover || this.props.hoverPdc
        ? MarkerStylesHover
        : this.state.isPdcPlannedBlink
        ? PlannedPdcStyle
        : MarkerStyles;
    const styleText =
      this.state.hover || this.props.hoverPdc
        ? { display: "block", fontSize: 10, paddingLeft: 5 }
        : { display: "none" };

    return (
      <div
        onMouseEnter={() => {
          this.setState({ hover: true });
          onHover(true);
        }}
        onMouseLeave={() => {
          this.setState({ hover: false });
          onHover(false);
        }}
        onClick={onClick}
        style={styleMarker}
      >
        {retailerLogos[retailerId] ? (
          <div
            style={{
              backgroundColor: MarkerColor(this.props.displayOption, { dn, last_visit_date, pdl }),
              height: 20,
              width: 20,
              borderRadius: "50%"
            }}
          >
            <img height={20} width={20} src={`/img/retailer/${retailerLogos[retailerId]}`} style={{ opacity: 0.6 }} />
          </div>
        ) : null}
        <div style={styleText}>
          {`${pdcLabel}`}
          {`${last_visit_date ? ` \n-\n dernière visite le ${moment(last_visit_date).format("DD/MM/YYYY")}` : ""}`}
          {`${dn ? ` \n-\n DN : ${Math.round(dn * 100) / 100}%` : ""}`}
          {`${pdl ? ` \n-\n PDL : ${Math.round(pdl * 100) / 100}%` : ""}`}
        </div>
      </div>
    );
  }
}

export default SalepointMarker;



// WEBPACK FOOTER //
// src/containers/activite/map/SalepointMarker.component.js